module.exports = __webpack_public_path__ + "media/images/background-8-6017e18855e7eaa9c717258904c4e989.svg";